import { createReducer } from 'utils';
import { UPDATE_BETSTOP } from 'constants/actions';

const initialState = {
  betstops: [],
};

export default createReducer(initialState, {
  [UPDATE_BETSTOP]: (state, payload) => ({
    ...state,
    betstops: payload,
  }),
});

export const getBetstops = state => state.betstops;
